<template>
  <div class="finished">

    <!-- App Header -->
    <AppHeader justify-space-between/>

    <AppNotificationBar>
      Application Successful. Confirmation Number: {{ confirmationNumber }}
    </AppNotificationBar>

    <StepContent column>
      <StepIcon
        :img-src="stepIcon"
      >
        <h3 class="icon_header">Your work is done! We will contact you soon.</h3>
      </StepIcon>

      <BorrowellBanner
        link="//cdriv.ca/bwonlinetypage"
        datalayer="finished_credit_check_apply"
      />
    </StepContent>

    <AppProgressCircles
      :index="stepIndex"
    />

    <!-- App Footer -->
    <AppFooter/>
  </div>
</template>

<script>
import AppFooter from '@/components/common/layout/AppFooter'
import AppNotificationBar from '@/components/common/notifications/AppNotificationBar'
import AppProgressCircles from '@/components/common/notifications/AppProgressCircles'
import AppHeader from '@/components/common/layout/AppHeader'
import BorrowellBanner from '@/components/common/borrowell/BorrowellBanner'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepIcon from '@/components/common/step/StepIcon'
import confirmationNumber from '@/mixins/confirmation-number'
import postAppProgress from '@/mixins/post-app-progress'
import DataLayer from '../../../data-layer'

export default {
  // Name
  name: 'finished',

  // Components
  components: {
    AppNotificationBar,
    AppProgressCircles,
    AppFooter,
    AppHeader,
    BorrowellBanner,
    StepContent,
    StepFooter,
    StepHeader,
    StepIcon
  },

  // Mixins
  mixins: [
    confirmationNumber,
    postAppProgress
  ],

  // Data
  data () {
    return {
      stepIcon: require('@/assets/svg/finished/finished.svg')
    }
  },

  // Computed
  computed: {
    stepIndex () {
      return this.progressStepsTotal - 1
    }
  },

  // Mounted
  mounted () {
    window.scrollTo(0, 0)
    const trackingData = { event: 'app_finished' }
    if (this.$store.state.application.notes) {
      trackingData.is_cosigner = true
    }
    DataLayer.track(trackingData)
  }
}
</script>

<style scoped lang="scss">
.finished {
  min-height: 100vh;

  // &__content {
  //   position: relative;
  //   min-height: 75vh;
  // }
}

.step-tooltip {
  margin-bottom: 30px;

  @include breakpoint('tablet-portrait-up') {
    margin-top: 0;
  }
}

.step-header {
  padding-bottom: 0;
}

.step-header :deep() {
  .step-header__title {
    color: $theme-text-blue;
  }
}

.icon_header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
  line-height: 19px;
  color: $theme-text-black;

  @include breakpoint('tablet-portrait-up') {
    font-size: 20px;
  }
}
</style>
